import axios from '../../localAxios';
import { workspaceQuizzesURL } from '../workspacesURLs';
import { WorkspaceQuiz } from './types';

interface GetWorkspaceQuizzesParams {
  workspaceId: string;
  isDeleted?: boolean;
}

export async function getWorkspaceQuizzes({
  workspaceId,
  isDeleted,
}: GetWorkspaceQuizzesParams) {
  const url = workspaceQuizzesURL({
    workspaceId: workspaceId,
    isDeleted: isDeleted,
  });
  const response = await axios.get<WorkspaceQuiz[]>(url.href);
  return response.data.map((workspaceQuiz) => ({
    ...workspaceQuiz,
  }));
}
